/**
 * Hostname-based branding for Tólspor vs Golfspor.
 *
 * Golfspor domains: golfspor.is, dev.golfspor.is, golf.localhost
 * Everything else defaults to Tólspor branding.
 * Native iOS builds: VUE_APP_BRAND=golfspor|tolspor (see mobile/ios/).
 */

import { Capacitor } from '@capacitor/core';

const hostname = window.location.hostname;

// Native iOS app (Capacitor) has no real hostname — the brand is fixed at build time.
const isGolfspor = Capacitor.isNativePlatform()
  ? process.env.VUE_APP_BRAND === 'golfspor'
  : hostname === 'golfspor.is' ||
    hostname.endsWith('.golfspor.is') ||
    hostname === 'golf.localhost';

const branding = isGolfspor
  ? {
      name: 'Golfspor',
      loginLogo: '/img/golfspor-login2.png',
      loginLogoClass: 'logo-golfspor',
      sidebarLogo: '/img/golfspor-sidebar.png',
      favicon: '/img/golfspor-favicon.png',
      sidebarType: 'bg-gradient-golfsporagraenn',
      buttonColor: 'golfsporagraenn',
      bodyClass: 'brand-golfspor',
      themeColor: '#216b2e',
    }
  : {
      name: 'Tólspor',
      loginLogo: '/img/tolsporA5.png',
      loginLogoClass: 'logo-tolspor',
      sidebarLogo: '/img/sidebar-header-tolspor2.png',
      favicon: '/img/icons/favicon-32x32.png',
      sidebarType: 'bg-gradient-tolsporagulur',
      buttonColor: 'tolsporagulur',
      bodyClass: '',
      themeColor: '#FFCD3A',
    };

export default branding;
